import React, { useState } from "react";
import CompaniesApi from "~/admin/apis/companies.api";
import InfluencersApi from "~/admin/apis/influencers.api";
import useDemands from "~/admin/hooks/useDemandsContext";
import PageDataLoader from "~/admin/components/PageDataLoader";
import TabBar from "~/admin/components/TabBar";
import useDataLoading from "~/admin/hooks/useDataLoading";
import useLayout from "~/hooks/useLayout";
import useMount from "~/hooks/useMount";
import CompaniesTab from "./CompaniesTab";
import InfluencersTab from "./InfluencersTab";

export default function DemandsPage() {
  const { setLayout } = useLayout();
  const { setDemands } = useDemands();
  const [activeTab, setActiveTab] = useState("influencers");
  const [influencers, setInfluencers] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [tabItems, setTabItems] = useState([
    {
      key: "influencers",
      title: "Influenceurs",
    },
    {
      key: "companies",
      title: "Entreprises",
    },
  ]);
  const dataLoading = useDataLoading();

  useMount(() => {
    setLayout({
      title: "Demandes",
      activeMenuKeys: ["demands"],
    });
    loadData();
  });

  const loadData = async (page = 1) => {
    dataLoading.start();
    setInfluencers([]);
    setCompanies([]);

    let error = null;
    const data = await Promise.all([
      InfluencersApi.paginateUnvalided(page),
      CompaniesApi.paginateUnvalided(page),
    ]).catch((e) => {
      error = e;
      return null;
    });

    dataLoading.stop(error);

    if (data) {
      setInfluencers(data[0]);
      setCompanies(data[1]);

      setDemands({
        demands: data[0].items.length + data[1].items.length,
      });

      const notifications = [data[0].items.length, data[1].items.length];

      setTabItems(
        tabItems.map((item, index) => {
          return {
            ...item,
            notifs: notifications[index],
          };
        })
      );
    }
  };

  const changeTab = (key) => {
    setActiveTab(key);
  };

  const searchInfluencer = async (page = 1) => {
    let influencers = await InfluencersApi.paginateUnvalided(page).catch(
      (e) => {
        return null;
      }
    );

    if (influencers) {
      setInfluencers(influencers);
    }
  };

  const onPaginateInfluencers = (page) => {
    searchInfluencer(page);
  };

  const searchCompanies = async (page = 1) => {
    let companies = await CompaniesApi.paginateUnalided(page).catch((e) => {
      return null;
    });

    if (companies) {
      setCompanies(companies);
    }
  };

  const onPaginateCompanies = (page) => {
    searchCompanies(page);
  };

  return (
    <PageDataLoader isLoading={dataLoading.isLoading}>
      <div className="w-full h-screen text-white flex flex-col">
        <div className="w-full min-h-[60px] border-b-2 border-slate-700 flex justify-between items-center px-10">
          <TabBar
            items={tabItems}
            activeItem={activeTab}
            onChange={changeTab}
          />
          <div className="font-bold text-2xl">Demandes</div>
        </div>
        <div className="p-6 overflow-auto">
          {activeTab === "influencers" && (
            <InfluencersTab
              influencers={influencers}
              onPaginate={onPaginateInfluencers}
            />
          )}
          {activeTab === "companies" && (
            <CompaniesTab
              companies={companies}
              onPaginate={onPaginateCompanies}
            />
          )}
        </div>
      </div>
    </PageDataLoader>
  );
}
